import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { State } from '..';
import { AIAssistant } from '@requests/telnyx';

type AssistantChange = {
  id: string;
  name: string;
  description: string;
  model: string;
  instructions: string;
  llm_api_key_ref: string | undefined;
};

export type assistantTypes = {
  createAssistant: AIAssistant | null;
  assistantChanges: AssistantChange[];
};

const initialState: assistantTypes = {
  createAssistant: null,
  assistantChanges: [],
};

export const getAssistantChanges = createSelector(
  [(state: State) => state.assistant.assistantChanges, (_, assistantId: string | null) => assistantId],
  (assistantChanges, assistantId) => assistantChanges.find((assistant) => assistant.id === assistantId)
);

const assistantSlice = createSlice({
  name: 'assistant',
  initialState,
  reducers: {
    createNewAssistant: (state, action: PayloadAction<AIAssistant | null>) => {
      if (action.payload === null)
        state.assistantChanges = state.assistantChanges.filter(
          (assistant) => assistant.id !== state.createAssistant?.id
        );

      state.createAssistant = action.payload;
    },
    updateAssistantChanges: (state, action: PayloadAction<AssistantChange>) => {
      if (state.assistantChanges.find((change) => change.id === action.payload.id)) {
        state.assistantChanges = state.assistantChanges.map((assistant) => {
          if (assistant.id === action.payload.id) return action.payload;
          return assistant;
        });
      } else state.assistantChanges.push(action.payload);
    },
    clearAssistantChanges: (state, action: PayloadAction<string>) => {
      state.assistantChanges = state.assistantChanges.filter((assistant) => assistant.id !== action.payload);
    },
  },
});

export const assistantActions = assistantSlice.actions;
export default assistantSlice.reducer;
